<template>
    <div>
      <me-action-sheet
        :value="sheetShow"
        :class="'action-title'"
        @cancel="$emit('cancel')"
        @click-overlay="$emit('cancel')"
        :closeable="false"
        :title="row.pageTempName"
      >
        <ul class="create-type">
          <me-col span="6">
            <li @click="preview">
                <me-icon name="description" />
                <div>查看</div>
            </li>
          </me-col>
          <me-col span="6" v-if="myLabel">
            <li @click="setting">
                <me-icon name="setting-o" />
                <div>设置</div>
            </li>
          </me-col>
          <me-col span="6" v-if="myLabel">
            <li @click="deleteTem">
                <me-icon name="delete-o" />
                <div>删除</div>
            </li>
          </me-col>
        </ul>
        <me-button block class="close-btn" @click="$emit('cancel')">关闭</me-button>
      </me-action-sheet>
    </div>
  </template>
  <script>
  import { Questionnaire } from '@/network'
  import { addClass2, removeClass2 } from '@/util/status-util'
  import { Toast } from '@guazi-fe/melon'
  import browser from '@/util/browser'
  import NativeApi from 'native-api'
  export default {
      props: {
          sheetShow: {
              type: Boolean,
              default: false,
          },
          title: {
            type: String,
            default: ''
          },
          myLabel: {
            type: Boolean,
            default: false
          },
          row: {
            type: Object,
            default: (_) => {}
          },
      },
      data() {
          return {
  
          }
      },
      methods: {
        preview() {
          const { guaguaApp: isApp } = browser
          let pageRoute = this.$router.resolve({
            name: 'previewTemplate',
            params: {
              pageId: this.row.pageTempId
            }
          })
          this.$emit('cancel')
          if (isApp) {
              NativeApi.invoke('createWebView', { url: `${location.href.split('#')[0]}${pageRoute.href}` })
              return
          }
          window.open(pageRoute.href, '_blank')
        },
        setting() {
          this.$store.commit('removeTemplateData')
          this.$store.commit('removeRangeList')
          this.$store.commit('updateLabelNames', [])
          sessionStorage.removeItem('templateName')
          const { guaguaApp: isApp } = browser
          let pageRoute = this.$router.resolve({
            name: 'templateSetting',
            params: {
              pageId: this.row.pageTempId
            },
          })
          this.$emit('cancel')
          if (isApp) {
              NativeApi.invoke('createWebView', { url: `${location.href.split('#')[0]}${pageRoute.href}` })
              return
          }
          window.open(pageRoute.href, '_blank')
        },
        deleteTem() {
          this.$emit('deleteTem', this.row.pageTempId)
        }
      },
  }
  </script>
  <style lang="scss" scoped>
  .me-action-sheet__header {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    width: 80%;
    margin: 0 auto;
    color: #303741;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .action-sheet {
  
    border-top: 0.5px solid #F2F4F6;
    margin-bottom: 10px;
  
    > .me-col {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .action-item {
        margin: 10px;
        .icon {
          width: 24px;
          height: 24px;
        }
        .txt {
          margin-top: 10px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .close-btn{
        border: none;
    }
  }
  .me-button--default{
    border: none;
    background: #F2F4F6;
  }
  .create-type{
    display: flex;
    margin: 10px 0;
    li{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #06B455;
      i{
        font-size: 36px;
      }
      div{
        margin: 10px 0;
        color: #9298A8;
      }
    }
  }
  .me-loading {
    position: absolute;
    z-index: 9000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  </style>
  